import React from 'react';
import cx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { ErrorRounded } from '@material-ui/icons';

interface UnsavedChangeIconProps {
  className?: string;
}

const UnsavedChangeIcon = (props: UnsavedChangeIconProps) => {
  const classes = useStyles();
  return <ErrorRounded className={cx(classes.root, props.className)} />;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fill: theme.palette.warning.main,
    fontSize: theme.typography.pxToRem(24)
  }
}));

export default UnsavedChangeIcon;
